import { current } from "@reduxjs/toolkit";
import { h } from "preact";
import { useEffect, useState } from "preact/hooks";

import { classNames, countryCodeToFlagUrl } from "../../helpers.js";
import i18n from "../../i18n.js";

import AutoSuggest from "../AutoSuggest.jsx";
import { getTextOfAnswer } from "./helper";
import Icon from "../Icon.jsx";

// TODO: Move that icon stuff somewhere else, so its not always done
const ICON_MAPPER = {
  flag: (_text, value) => countryCodeToFlagUrl(value),
};

export default function Combobox(props) {
  const iconMapper = ICON_MAPPER[props.options?.icon];
  const [suggestions, setSuggestions] = useState([]);
  const [currentAnswer, setCurrentAnswer] = useState(
    getTextOfAnswer(props.answer) || ""
  );

  useEffect(() => {
    setSuggestions(
      props.options.suggestions.map(([text, normalized]) => ({
        image: iconMapper ? iconMapper(text, normalized) : null,
        text,
      }))
    );
  }, [props.options?.suggestions]);

  useEffect(() => {
    setCurrentAnswer(getTextOfAnswer(props.answer) || "");
  }, [props.answer]);

  function handleChange(eventOrValue) {
    const value =
      typeof eventOrValue === "string"
        ? eventOrValue
        : eventOrValue.target.value;

    setCurrentAnswer(value || "");
    selectValue(value, eventOrValue);
  }

  function selectValue(value, eventOrValue) {
    // TODO: this does not work as expected without onlySuggestions == true
    const error = validationError(value);

    const sendingValue = props.options.suggestions.find(
      ([text, _norm]) => eventOrValue == text
    );
    props.onSelect(sendingValue || [value || ""], eventOrValue, error);
  }

  function validationError(value) {
    if (!props.options.onlySuggestions) return null;
    const lowerValue = value.toLowerCase();
    if (
      props.options.suggestions.find(
        ([text, _val]) => text.toLowerCase() == lowerValue
      )
    ) {
      return null;
    } else {
      return i18n.t(
        props.options.suggestionError || "component.combobox.default_error"
      );
    }
  }

  return (
    <AutoSuggest
      suggestions={suggestions}
      value={currentAnswer}
      onChange={handleChange}
      inputProps={{
        id: "question-suggested",
        name: "answer",
        class: classNames("autocomplete", props.options?.icon),
        value: currentAnswer,
        autocomplete: "off",
        info: props.options.helperText,
        error: props.error,
        label: props.options.label,
        disabled: props.disabled,
        iconAfter: props.options.onlySuggestions && (
          <Icon>keyboard_arrow_down</Icon>
        ),
      }}
    />
  );
}
